import React from 'react';
import { useIntl } from 'umi';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';

export default function SpecialColHeader(props) {
  const {
    config,
    getIsHideCol
  } = props;


  const {
    type,
    title,
    align = 'right',
    childWidth,
    childAlign
  } = config || {};

  const { formatMessage } = useIntl();

  const getElContent = (_type: string) => {
    switch (_type) {
      case 'text':
        return (
          <div className="dbi-table-header">
            <div className="table-header-text">{formatMessage({ id: title })}</div>
          </div>
        )
      case 'action':
        return (
          <div className="dbi-table-header">
            <div className="table-header-text">{formatMessage({ id: title })}</div>
          </div>
        )
      default:
        return null;
    }
  }
  return (
    <>
      {
        align === 'center'
          ? <CloumsCenter width={childWidth} align={childAlign}>
            {getElContent(type)}
          </CloumsCenter>
          : getElContent(type)
      }
    </>
  )
}